module.exports = __webpack_public_path__ + "static/grafika8@2x-1a7830606ff5b9954db6bfdaf0bb7565.png";